export const AUTO_WIRE_TOAST_TIMEOUT = 12000;
export const AUTO_WIRE_UNDO_TOAST_TIMEOUT = 8000;
